<template>
  <div>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card title="Invoices" v-can:any="['create-user-role', 'view-user-role']">
        <template slot="actions">
<!--          <vs-button  v-can="'create-user-role'" @click="createGroupPopUp" class="" color="primary" type="filled">Create Role</vs-button>-->
          <span>{{tenant_details.gocardless_id !== '' ? `goCardLess ID: ${tenant_details.gocardless_id}` : ''}}</span>
          <vs-button v-if="tenant_details.gocardless_id === ''" @click="createInvoicePopup" color="primary" type="filled">Create Invoice</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-table v-can="'view-user-role'" :max-items="(meta.per_page) ? meta.per_page : 10" @sort="handleSort" :sst="true" :data="invoices" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th sort-key="name">Tenant</vs-th>
              <vs-th>Number</vs-th>
              <vs-th>Period</vs-th>
              <vs-th>Setup Charge</vs-th>
              <vs-th>Price</vs-th>
              <vs-th>Discount</vs-th>
              <vs-th>Status</vs-th>
              <vs-th v-can="'edit-user-role'" >ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :key="index" v-for="(tr, index) in invoices">

                <vs-td :data="data[index].tenant">
                  {{ data[index].tenant }}
                </vs-td>
                <vs-td :data="data[index].number">
                  {{ data[index].number}}
                </vs-td>
                <vs-td :data="data[index].period">
                  {{ data[index].period}}
                </vs-td>
                <vs-td :data="data[index].setup_charge">
                  {{ data[index].setup_charge}}
                </vs-td>
                <vs-td :data="data[index].price">
                  {{ data[index].price}}
                </vs-td>
                <vs-td :data="data[index].customer_portal_discount">
                  {{ data[index].customer_portal_discount}}
                </vs-td>
                <vs-td :data="data[index].status">
                  {{ data[index].status}}
                </vs-td>
                <vs-td v-can="'view-user-role'">
                  <div class="vx-row">
                    <vx-tooltip text="Edit" class="ml-5">
                      <vs-button @click="onClickUserView(data[index].id)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="Pay" class="ml-5">
                      <vs-button @click="invoicePayment(data[index])"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-dollar-sign"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 1" v-model="page"  class="p-5"></vs-pagination>
        </div>
      </vx-card>
    </div>
  </div>
    <create-invoice-pop-up ref="CreateInvoicePopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import Filter from '@/mixins/filter';
import CreateInvoicePopUp from "@/components/popups/tenants/invoice/CreateInvoicePopUp";
import {GoCardLessRedirectUri,GoCardLessExitUri, baseUri} from "@/constants/config";
import ErrorMessages from "@/mixins/ErrorMessages";

const InvoiceRepository = RepositoryFactory.get('invoice')
const TenantRepository = RepositoryFactory.get('tenant')
const GoCardLessRepository = RepositoryFactory.get('goCardless')

export default {
  name: "TenantInvoice",
  data () {
    return {
      invoices: [],
      meta:{},
      tenantId:null,
      page : 1,
      sort: '',
      tenant_details:{}
    }
  },
  mixins:[Filter,ErrorMessages],

  components: {
    CreateInvoicePopUp
  },
  mounted() {
    this.tenantId = this.$route.params.id
    this.loadInvoiceList()
    this.fetchTenantDetails()
  },
  methods:{
    async loadInvoiceList() {
      this.$vs.loading()
      const {data} = await InvoiceRepository.get(this.tenantId,this.page,10)
      this.invoices = data.data;
      this.meta = data.meta;
      this.$vs.loading.close()
    },
    async fetchTenantDetails() {
      try {
        const { data } = (await TenantRepository.getTenantDetails(this.tenantId)).data
        this.tenant_details = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadInvoiceList()
      }

    },
    onClickUserView(){
      //
    },

    async invoicePayment(tenant){
      try {
        this.$vs.loading()
        const payload = {
          tenant_id: this.tenantId,
          payment_request: {
            description: 'Invoice First Payment',
            amount: this.changeAmountFormat(tenant.setup_charge),
            currency: 'GBP',
            app_fee: this.changeAmountFormat(tenant.price)
          },
          mandate_request: {
            scheme: 'bacs',
            currency: 'GBP'
          }
        }
        const {data} = await GoCardLessRepository.createBillingRequest(payload)
        this.$vs.loading.close()
        if (data) {
          await this.billingRequestFlow(data.billing_requests.id)
        }
      }catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    changeAmountFormat(amount){
      return amount*100;
    },
    async billingRequestFlow(billingRequestId) {
      try {
        this.$vs.loading()
        const payload = {
          redirect_uri: `http://${baseUri}/pages/tenants/${this.tenantId}?step=3`,
          exit_uri: `http://${baseUri}/pages/tenants/${this.tenantId}?step=3`,
          links: {
            billing_request: billingRequestId
          }
        }
        const {data} = await GoCardLessRepository.createBillingRequestFlow(payload)
        this.$vs.loading.close()
        window.location.href = data.billing_request_flows.authorisation_url
      }catch (error){
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
    },
    async createInvoicePopup(){
      await this.$refs.CreateInvoicePopUp.openPopUp();
    },
    handleChangePage(page) {
      this.page=page;
      this.loadInvoiceList()
    },
    filterQueryUpdate() {
      this.loadInvoiceList()
    }
  },
  watch : {
    page(){
      this.loadInvoiceList()
    }
  },
}
</script>

<style scoped>

</style>
